import React from 'react';
import { Attribution, Box, Button, Heading, Text, createButtonColorConfig } from '@99designs/emu';
import { colors } from '@99designs/emu/settings';
import { SadDragonImage } from './SadDragonImage';

const ctaColorConfig = createButtonColorConfig({
    normal: {
        backgroundColor: colors.experimental.yellow300,
        backgroundColorHover: colors.experimental.yellow400,
        backgroundColorActive: colors.experimental.yellow500,
        borderColor: 'transparent',
        borderColorHover: 'transparent',
        borderColorActive: 'transparent',
        textColor: 'grey900',
        textColorHover: 'grey900',
        textColorActive: 'grey900',
    },
});

export type NoResultsProps = {
    heading: React.ReactNode;
    message: React.ReactNode;
    cta: React.ReactNode;
    image: React.ReactNode;
    attribution: React.ReactNode;
};

function NoResults({ heading, message, cta, image, attribution }: NoResultsProps) {
    return (
        <Box display={'flex'} flexDirection={['column', 'row']}>
            <Box marginRight={['none', '6bu']}>
                <Box marginBottom={'0.75bu'}>{heading}</Box>
                <Box marginBottom={'1.5bu'} maxWidth={'400px'}>
                    {message}
                </Box>
                {cta}
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                marginTop={['1.5bu', 'none']}
                maxWidth={'230px'}
                alignSelf="center"
            >
                {image}
                <Box marginTop={'1bu'} alignSelf="center">
                    {attribution}
                </Box>
            </Box>
        </Box>
    );
}

type NoResultsBrowseProps = {
    onCtaClick: () => void;
};
export function NoResultsBrowse({ onCtaClick }: NoResultsBrowseProps) {
    return (
        <NoResults
            heading={
                <Heading appearanceLevel={4} accessibilityLevel={7}>
                    {__placeholder('Sorry, we couldn’t find any search results!')}
                </Heading>
            }
            message={
                <Box>
                    <Text>{__placeholder("Here's what you can try:")}</Text>
                    <ul>
                        <li>{__placeholder('Check your spelling')}</li>
                        <li>{__placeholder('Change your filter settings')}</li>
                        <li>{__placeholder('Try more general search terms')}</li>
                        <li>{__placeholder('Try fewer search terms')}</li>
                    </ul>
                </Box>
            }
            cta={
                <Button
                    appearance={ctaColorConfig}
                    onClick={onCtaClick}
                    width={['fill', 'auto', 'auto', 'auto']}
                >
                    {__placeholder('Clear filters')}
                </Button>
            }
            image={<SadDragonImage />}
            attribution={<Attribution>{__placeholder('Mascot design by leargamar')}</Attribution>}
        />
    );
}

type NoResultsShortlistProps = {
    onCtaClick: () => void;
};
export function NoResultsShortlist({ onCtaClick }: NoResultsShortlistProps) {
    return (
        <NoResults
            heading={
                <Heading appearanceLevel={4} accessibilityLevel={7}>
                    {__placeholder('Your shortlist is currently empty')}
                </Heading>
            }
            message={
                <Box>
                    <Text>
                        {__placeholder(
                            'Start adding items by browsing designs from our community’s top talent and clicking the heart icon on designs you’re inspired.'
                        )}
                    </Text>
                </Box>
            }
            cta={
                <Button
                    appearance={ctaColorConfig}
                    onClick={onCtaClick}
                    width={['fill', 'auto', 'auto', 'auto']}
                >
                    {__placeholder('Browse inspirations')}
                </Button>
            }
            image={<SadDragonImage />}
            attribution={<Attribution>{__placeholder('Mascot design by leargamar')}</Attribution>}
        />
    );
}
